import { useSelector } from 'react-redux'
import { remindersConfigSelector } from '@src/selectors/app'
import { remindersSelector } from '@src/selectors/settings'

export const useAvailableReminders = () => {
  const remindersConfig = useSelector(remindersConfigSelector)
  const userReminders = useSelector(remindersSelector)

  return remindersConfig.filter(({ key }) => !userReminders.some(({ kind }) => key === kind))
}
